<template>
    <div class="w-0 my-2 mx-2 mx-lg-0 mx-md-0">
        <div :class="{'position-absolute select-label fs-7': isStyled}" v-if="label.length" :style="{backgroundColor: bgColor}">
            {{ label }}
        </div>
        <!-- {{ list }} -->
        <select 
            class="form-select form-select-lg rounded-0 w-100 fs-6 bg-transparent border border-2" 
            style="border: 2px solid rgba(0,0,0,0.2) !important;" 
            aria-label=".form-select-lg example"
            v-model="modelValueRef"
        >
            <!-- <option value="" selected>Select option</option> -->
            <option :value="item" v-for="(item, i) in list" :key="i" :disabled="item.selected" :selected="item.selected">{{item.name}}</option>
        </select>
    </div>
</template>

<script setup>
import { useVModel } from "@/fuel-station/useVModel";

const props = defineProps({
    modelValue: {
        type: [Object, Array, String],
        default: {
            id: 0,
            name: "Select One"
        },
    },
    option: {
        type: Object,
        default: null,
    },
    label: {
        type: String,
        default: ""
    },
    list: {
        type: Array,
        default: ()=> [{
            id: 0,
            name: "Select One"
        }]
    },
    isStyled: {
        type: Boolean,
        default: true
    },
    bgColor: {
        type: String,
        default: "#fff"
    }
});

const emit = defineEmits(['update:modelValue']);
const modelValueRef = useVModel(props, emit, "modelValue");
// const selectOption = ref(null);

// const setOption = ()=> {
//     if (condition) {
        
//     }
// };

// watch(selectOption, () => {
//     if (selectOption.value != null) {
//         emit('update:modelValue', selectOption.value);
//     }
// })

// watchEffect(()=> setOption() );
</script>

<style lang="scss" scoped>
.select-label {
    top: -10px;
    left: 13px;
    z-index: 99;
    padding: 0 5px;
}


.form-select:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>